import store from 'store2'

import post from '../../../lib/post'

export default function(o,email,firstName,lastName,lang,done){

  post(
    'auth',
    {
      type: 'sendWelcomeMail',
      email: email,
      firstName: firstName,
      lastName: lastName,
      lang: lang,
      token: o.store('token'),
    },
    function(error, result){
      if(error){
        done(error)
      } else {
        o.sounds.beep.play()
        o.feedback.ok('welcome mail sent')
        done()
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/authSendWelcomeMail.js